import React from 'react';
import axios from 'axios';
import '../css/navBar.css';
import { handleError, toastError } from '../funciones';


function PaginacionRegistro(props){
    
    const partesRegister = ['datosEmpresa', 'ofertaDemanda', 'datosRepresentante', 'resumen']; 
    const idBoxPag = [['razonSocial', 'email', 'cuit', 'contraseña', 'confirmarContraseña', 'uniones',
        'descripcionEmpresa', 'telefono', 'calle', 'altura', 'localidad', 'codigoPostal']]; 

    function paginaSiguiente(){
        var permitirPasar = true;

        if(props.paginaActual === 1){
            idBoxPag[props.paginaActual - 1].forEach(e => {
                if(!document.getElementById(e).value){
                    document.getElementById(e).classList.add("texBoxError");
                    permitirPasar = false;
                }
            })
            if(!permitirPasar)
                toastError("Debe completar todos los campos")
            const contraseña = document.getElementById("contraseña").value;
            const contraseñaCopia = document.getElementById("confirmarContraseña").value;
            if(contraseña.localeCompare(contraseñaCopia) !== 0){
                document.getElementById("confirmarContraseña").classList.add("texBoxError");
                permitirPasar = false;
                toastError("Las contraseñas deben coincidir")
            }
            else{
                if( permitirPasar && (!localStorage.getItem(process.env.REACT_APP_CODIGO_APROBADO) 
                || !sessionStorage.getItem(process.env.REACT_APP_CODIGO_REGISTRO)
                || !localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA)
                || localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA).localeCompare(document.getElementById("email").value) !== 0) ){
                     localStorage.setItem(process.env.REACT_APP_MAIL_EMPRESA, document.getElementById("email").value);
                    localStorage.removeItem(process.env.REACT_APP_CODIGO_APROBADO)
                    document.getElementById('abrirModalCodigo').click();
                    if(document.getElementById("inputMailRecuperar") !== null)
                        document.getElementById("inputMailRecuperar").classList.add("d-none"); 
                    permitirPasar = false;
                }
            }
        }
        else if(props.paginaActual === 2) {
            if(props.badgesRubro.length === 0){
                permitirPasar = false;
                toastError("Debe seleccionar al menos un rubro")
            }
        }
        else if(props.paginaActual === 3) {
            if(props.representantes.length === 0){
                permitirPasar = false;
                toastError("Debe ingresar al menos un representante")
            }
            if(!props.aceptaTerminos){
                toastError("Debe aceptar los Términos y Condiciones")
                permitirPasar = false;
            }
        }

        if(permitirPasar){
            if(props.paginaActual + 1 >= 4){
                crearEmpresa();

            }else{
                if(props.paginaActual + 1 === 3){
                    const btnSiguiente = document.getElementById("btnSiguiente");
                    document.getElementById('cont-terminosCondiciones').classList.remove("d-none");
                    btnSiguiente.innerText="Registrarse";
                }else if(props.paginaActual + 1 === 2){
                    const btnAnterior = document.getElementById("btnAnterior");
                    btnAnterior.innerText = "Anterior";
                    

                } 

                
                props.setPaginaActual(props.paginaActual + 1);
                const parte1 = document.getElementById(partesRegister[props.paginaActual]);
                parte1.classList.remove("d-none");
                const parte2 = document.getElementById(partesRegister[props.paginaActual - 1]);
                parte2.classList.add("d-none");
                
                document.getElementById("scrollRegistro").scroll(0, 0);

            }
        }
    }

    function crearEmpresa(){
        let productosOfrecidos = []; 
        let productosDemandados = []; 
        let rubros = []; 
        //props.badgesDemanda.forEach(e => {productosDemandados.push(e.label)})
        if(props.badgesOferta.length !== 0)
            props.badgesOferta.forEach(e => {productosOfrecidos.push(e.label)})
        else
            productosOfrecidos.push('');
        if(props.badgesDemanda.length !== 0)
            props.badgesDemanda.forEach(e => {productosDemandados.push(e.label)})
        else
            productosDemandados.push('');
        props.badgesRubro.forEach(e => {rubros.push(e.value)})
        let representantes = []; 
        props.representantes.forEach(e => {representantes.push({apellido: e.apellido, nombre: e.nombre, cargo: e.cargo, eliminado: false})})
        var pagWeb = document.getElementById("paginaWeb").value;
        if(pagWeb === ""){
            pagWeb = "No posee"
        }
        const params = {
            cuitTemp: parseInt(document.getElementById("cuit").value),
            password: document.getElementById("contraseña").value,
            nombre: document.getElementById("razonSocial").value,
            descripcion: document.getElementById("descripcionEmpresa").value,
            email: document.getElementById("email").value,
            calle: document.getElementById("calle").value,
            altura:  document.getElementById("altura").value,
            codigoPostal:  parseInt(document.getElementById("codigoPostal").value),
            localidad: document.getElementById("localidad").value,
            numeroTelefono:  parseInt(document.getElementById("telefono").value),
            paginaWeb: pagWeb,
            rubros: rubros,
            unionLaboral: parseInt(document.getElementById("uniones").value) + 1,
            productosOfrecidos: productosOfrecidos,
            productosDemandados: productosDemandados,
            representantes: representantes,
            codigo: sessionStorage.getItem(process.env.REACT_APP_CODIGO_REGISTRO)
        }
        axios
        .post(process.env.REACT_APP_URL + 'empresa', params)
        .then((res) => {
            sessionStorage.removeItem(process.env.REACT_APP_CODIGO_REGISTRO);
            localStorage.setItem(process.env.REACT_APP_USUARIO_CREADO, 1);
            document.location.href ='/';
        })
        .catch(function (error) {
            // 404: el código ya no sirve; al volver al primer paso se pide uno nuevo
            if (error.response?.status === 404) {
                sessionStorage.removeItem(process.env.REACT_APP_CODIGO_REGISTRO);
                localStorage.removeItem(process.env.REACT_APP_CODIGO_APROBADO);
            }
            toastError(handleError(error))
        })
    }

    function paginaAnterior(){
        if(props.paginaActual -1 === 0){
            document.location.href ='/';
        }
        else{
            if(props.paginaActual - 1 === 1){
                const btnAnterior = document.getElementById("btnAnterior");
                btnAnterior.innerText = "Volver";
            }else if(props.paginaActual - 1 === 2){
                const btnSiguiente = document.getElementById("btnSiguiente");
                btnSiguiente.innerText="Siguiente";
                document.getElementById('cont-terminosCondiciones').classList.add("d-none");
            }
            props.setPaginaActual(props.paginaActual - 1);
            const parte1 = document.getElementById(partesRegister[props.paginaActual -2]);
            parte1.classList.remove("d-none");
            const parte2 = document.getElementById(partesRegister[props.paginaActual - 1]);
            parte2.classList.add("d-none");
            document.getElementById("scrollRegistro").scroll(0, 0);
        }
    }

    return(  
        <>  
           
            <div className='row   py-5'>
                <div className='col text-end '>
                    <button id="btnAnterior" class="btn btn-outline-primary bold-botones  " type="submit"  onClick={paginaAnterior} >Volver</button>
            
                    {/*<button id="btnSiguiente" class="btn colorPrincipal text-white bold-botones mx-3 ocultarMobile" type="submit" onClick={paginaSiguiente}>Siguiente</button>*/}
                </div>
                <div className='col  '>
                    <button id="btnSiguiente" class="btn colorPrincipal text-white bold-botones" type="submit" onClick={paginaSiguiente}>Siguiente</button>
                </div>
            </div>
                
        </>
    );
}

export default PaginacionRegistro;